import React, { useRef, useState } from 'react'
import {
  NavItemButton,
  NavItemLabel,
  NavItemIconLabelGroup,
  NavItemLabelAndIconContainer,
  NavItemMenu,
  NavItemMenuItem,
} from './NavItemBlock.styled'
import { NavItem } from '../types'

export const NavItemBlock = ({
  item,
  activeItemId,
  isCollapsed = false,
}: {
  item: NavItem
  activeItemId: string
  isCollapsed?: boolean
}) => {
  const anchorRef = useRef(null)
  const [open, setOpen] = useState(false)
  const handleMenuClick = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const isSelected = item.id === activeItemId

  const makeHandleClick =
    (target: NavItem) =>
    (
      event:
        | React.MouseEvent<HTMLButtonElement, MouseEvent>
        | React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => {
      if (!target.allowClickDefault) {
        // Avoid redirects when setting the href attr
        event.preventDefault()
      }

      if (target.handleClick) {
        target.handleClick(event)
      }

      if (target.subMenuItems) {
        handleMenuClick()
      }
    }

  const NavItemComponent = item.href
    ? NavItemButton.withComponent('a')
    : NavItemButton

  return (
    <>
      <NavItemComponent
        ref={anchorRef}
        onClick={makeHandleClick(item)}
        href={item.href}
        target={item.spawn ? '_blank' : undefined}
        rel={item.spawn ? 'noopener noreferrer' : undefined}
        isActive={isSelected}
        isCollapsed={isCollapsed}
      >
        <NavItemIconLabelGroup isCollapsed={isCollapsed}>
          <NavItemLabelAndIconContainer isCollapsed={isCollapsed}>
            {item.Icon && (
              <NavItemLabel isIcon isCollapsed={isCollapsed}>
                <item.Icon
                  color='var(--navItemIconColor)'
                  variant={isSelected ? 'filled' : 'outlined'}
                />
              </NavItemLabel>
            )}
            {!isCollapsed && (
              <NavItemLabel isCollapsed={isCollapsed}>
                {item.label}
              </NavItemLabel>
            )}
          </NavItemLabelAndIconContainer>
          {!isCollapsed && item.chip && item.chip}
        </NavItemIconLabelGroup>
      </NavItemComponent>
      {item.subMenuItems ? (
        <NavItemMenu
          container={anchorRef.current}
          anchorEl={anchorRef.current}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transitionDuration={200}
        >
          {item.subMenuItems.map((subMenuItem) => (
            <NavItemMenuItem key={subMenuItem.id} disableRipple>
              <a href={subMenuItem.href} onClick={makeHandleClick(subMenuItem)}>
                {subMenuItem.label}
              </a>
            </NavItemMenuItem>
          ))}
        </NavItemMenu>
      ) : null}
    </>
  )
}
